// src/pages/methods.scroll.js

export function initScrollBehavior(containerSelector = "#home-sections", options = {}) {
  const { isScrollable = false } = options;
  if (!isScrollable) return; // If scrolling behavior is not enabled, exit

  const container = document.querySelector(containerSelector);
  if (!container) return; // Exit if container not found

  const sections = container.querySelectorAll("section");
  if (sections.length === 0) return; // Exit if no sections found

  // If footer has scroll snap class, enforce scroll snap behavior on Y axis
  const scrollableFooter = document.querySelector('.scroll-snap-footer');
  if (scrollableFooter) {
    scrollableFooter.style.scrollSnapType = 'y mandatory';
  }

  let currentSectionIndex = 0; // Track currently visible section index
  let isScrolling = false;     // Flag to prevent multiple simultaneous scrolls

  // Touch variables and threshold (for future use)
  // let touchStartY = 0;
  // let touchEndY = 0;
  // const TOUCH_THRESHOLD = 20;

  // Function to smoothly scroll to a specific section by ID
  function scrollToSection(sectionId) {
    const targetSection = document.getElementById(sectionId);
    if (!targetSection) return;

    isScrolling = true; // Mark scrolling in progress
    targetSection.scrollIntoView({ behavior: 'smooth' });

    // After 500ms (approximate smooth scroll duration), reset scrolling flag
    setTimeout(() => {
      isScrolling = false;
    }, 500);
  }

  // Use IntersectionObserver to update currentSectionIndex based on viewport visibility
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const index = Array.from(sections).indexOf(entry.target);
        if (index !== -1) {
          currentSectionIndex = index;
        }
      }
    });
  }, {
    threshold: 0.6 // Consider section visible if 60% in viewport
  });

  sections.forEach(section => observer.observe(section));

  // Handle mouse wheel scroll events to trigger snap scroll between sections
  function handleWheel(e) {
    if (isScrolling) return; // Ignore if already scrolling
    e.preventDefault();

    const direction = e.deltaY > 0 ? 1 : -1; // Scroll down or up
    const newIndex = currentSectionIndex + direction;

    if (newIndex >= 0 && newIndex < sections.length) {
      currentSectionIndex = newIndex;
      scrollToSection(sections[currentSectionIndex].id);
    }
  }

  // Touch event handlers for mobile swipe scroll (currently commented out)
  /*
  function handleTouchStart(e) {
    touchStartY = e.touches[0].screenY;
  }

  function handleTouchEnd(e) {
    if (isScrolling) return;
    touchEndY = e.changedTouches[0].screenY;
    const diff = touchStartY - touchEndY;

    // Ignore small swipes
    if (Math.abs(diff) < TOUCH_THRESHOLD) return;

    const direction = diff > 0 ? 1 : -1;
    const newIndex = currentSectionIndex + direction;

    if (newIndex >= 0 && newIndex < sections.length) {
      currentSectionIndex = newIndex;
      scrollToSection(sections[currentSectionIndex].id);
    }
  }
  */

  // Add event listeners for mouse wheel (active) and touch (commented out)
  window.addEventListener('wheel', handleWheel, { passive: false });
  // window.addEventListener('touchstart', handleTouchStart, { passive: true });
  // window.addEventListener('touchend', handleTouchEnd, { passive: true });

  // Cleanup function to remove listeners and observers when needed
  return () => {
    window.removeEventListener('wheel', handleWheel);
    // window.removeEventListener('touchstart', handleTouchStart);
    // window.removeEventListener('touchend', handleTouchEnd);
    observer.disconnect();
  };
}
